export default __webpack_public_path__ + "static/media/ThoroughbredPark.9a5e241b.svg";